import { copy } from "../copy";

// The chrome wordmark. The specular sweep is pure CSS (.bf-chrome-text).
// Only the hero passes testId, so the page has exactly one "wordmark".
export default function ChromeWordmark({ className = "", testId }: { className?: string; testId?: string }) {
  return (
    <span
      data-testid={testId}
      className={`bf-chrome-text font-headline uppercase leading-none tracking-[-0.01em] ${className}`}
    >
      {copy.brand}
    </span>
  );
}
